import React, { useState, useEffect, useContext } from 'react';
import { USBGrid, USBColumn, USBSelect, USBButton } from '@usb-shield/components-react';
import { endpoints } from '../../../../config/connections';
import USBBreadcrumb from '@usb-shield/components-react/dist/cjs/breadcrumb';
import Loader from '../../../components/utilities/Loader';
import '@usb-shield/react-forms-base/dist/library/styles/index.css';
import '../Reports';
import './lookup-report.css';
import useUserRole from '../../../components/Hooks/use-UserRole';
import _noaccess from '../../../pages/_noaccess';
import { ShieldTable } from '../../../components/shared/Table';
import callApi from '../../../components/utilities/callApi';

const LookupSearch = () => {
  const [fullData, setFullData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchEntityList, setSearchEntityList] = useState([]);
  const [searchInput, setSearchInput] = useState('');
  const disableButton = searchInput ? false : true;

  const [catogory, setCatagory] = useState('');
  const [searchPerformed, setSearchPerformed] = useState(false);
  const [clearFilterFlag, setClearFilterFlag] = useState(false);

  const getFilterData = async () => {
    setLoading(true);
    const url = `${endpoints.apigee}/document-management/cdc/requirements/v1/getSearchCategories`;
    try{ 
      const response = await callApi.getApiData(url);
      if (response) {
        setSearchEntityList(formatFilterData(response?.data, 0));
        setLoading(false);
      }
    } catch(e){
      //error
      setLoading(false);
    }
  };

  const formatFilterData = (list, indicator) => {
    const newData = [{ content: 'Select', value: '' }];
    if (indicator === 0) {
      list.forEach((element) => {
        let splitvalue = element.split('-');
        newData.push({ content: splitvalue[0], value: splitvalue[1] });
      });
    }
    return newData;
  };
  const clearSerchValue = () => {
    setLoading(true);
    setSearchInput('');
    setCatagory('');
    setSearchEntityList([]);
    setClearFilterFlag(true);
    getFilterData();
    setFullData([]);
    setSearchPerformed(false);
    setLoading(false);
    setTimeout(() => setClearFilterFlag(false), 0);
  };

  const SearchValueBYEntity = async () => {
    const url = `${endpoints.apigee}/document-management/cdc/requirements/v1/getSearchDetails?category=${catogory}&value=${searchInput}`;
    try {
      const response = await callApi.getApiData(url);
      if (response) {
        if(catogory === 'dealId'){
          const filteredData = response?.data?.filter((item) => item?.dealNumber === searchInput);
          setFullData(filteredData);
        } else {
          setFullData(response?.data);
        }
        setLoading(false);
    }} catch(e){
      setSearchPerformed(true);
      setLoading(false)
    }
  };

  useEffect(() => {
    getFilterData();
  }, []);

  const tempUserRole = useUserRole();

  const columns = [
    {
      headerName: 'Parent Company',
      key: 'parentCompanyName',
      dataType: 'string',
      sortable: true,
    },
    {
      headerName: 'Deal Name',
      key: 'dealName',
      dataType: 'string',
      sortable: true,
    },
    {
      headerName: 'Deal Number',
      key: 'dealNumber',
      dataType: 'string',
      sortable: true,
    },
    {
      headerName: 'Fund Name',
      key: 'syndicationFundName',
      dataType: 'string',
      sortable: true,
    },
    {
      headerName: 'Legal Entity',
      key: 'reportingEntity',
      dataType: 'string',
      sortable: true,
    },

    {
      headerName: 'PSA Leads',
      key: 'psalead',
      dataType: 'string',
      sortable: true,
    },
    {
      headerName: 'Fund Manager',
      key: 'fundManager',
      dataType: 'string',
      sortable: true,
    },
  ];

  return tempUserRole && tempUserRole != 'employee' ? (
    <_noaccess />
  ) : (
    <>
      <USBGrid addClasses="content-frame">
        <USBColumn largeSpan={8}>
          <USBBreadcrumb
            id="reports"
            data-testid="breadcrumb"
            text="Reports"
            breadcrumbs={[
              { id: 2, text: 'Reports', href: '/Reports/Lookup' },
              { id: 3, text: 'Lookup Report', href: '' },
            ]}
          />
        </USBColumn>
        <USBColumn largeSpan={8}></USBColumn>
      </USBGrid>
      <USBGrid  data-testid="main" addClasses="content-frame content-bg">
        {loading ? <Loader /> : null}
        <USBColumn largeSpan={16}>

        {/* <h1 className="heading-h1"  data-testid="heading">Lookup Report</h1> */}
         
          <div className="sorting-inputs">
            <div className="filter-dropdowns leftlabel SearchBy" style={{width:"12%"}}>
              {!clearFilterFlag && searchEntityList.length > 0 ? (
                <USBSelect
                  name="globalSearch"
                  id="globalSearch"
                  data-testid="dropdown" 
                  inputName="GlobalSearch"
                  labelText="Search By"
                  optionsArray={searchEntityList}
                  initValue=""
                  handleChange={(event) => {
                    setCatagory(event?.target?.value);
                  }}
                  errorMessages={{ 224: 'Please select an option' }}
                />
              ) : null}
            </div>
            <div className="filter-dropdowns-lookup searchInputValue">
              <label>
                <input
                  type="text"
                  data-testid="main" 
                  name="name"
                  id="searchInput"
                  size={30}
                  value={searchInput}
                  onChange={(e) => {
                    setSearchInput(e.target.value);
                  }}
                />
              </label>
            </div>
            <div className="filter-dropdowns-lookup searchButton">
              <USBButton
                type="button"
                variant="primary"
                size="small"
                id="searchButton"
                name="searchButton"
                disabled={disableButton}
                handleClick={() => {
                  SearchValueBYEntity();
                }}
              >
                Search
              </USBButton>
            </div>
            <div className="filter-dropdowns-lookup clear">
              {searchEntityList.length > 0 ? (
                <USBButton
                  type="button"
                  variant="text"
                  size="small"
                  id="clearButton"
                  data-testid="clearButton"
                  name="clearButton"
                  handleClick={() => {
                    clearSerchValue();
                  }}
                >
                  Clear Filter
                </USBButton>
              ) : null}
            </div>
          </div>
          <div className="sorting-inputs"></div>

          {fullData.length > 0 ? (
            <div className="page-content">
              <ShieldTable
                data={fullData}
                columns={columns}
                defaultSort={{ key: 'parentCompanyName', direction: 'asc' }}
                pagination={{ pageSize: 10 }}
                className="usb-theme"
                emptyMessage="No search results found"
              />
            </div>
          ) : searchPerformed ? (
            <div className="page-content" style={{ padding: '20px 0', textAlign: 'center', color: '#6e6e6e' }}>
              <p>No results found. Please refine your search criteria.</p>
            </div>
          ) : null}
        </USBColumn>
      </USBGrid>
    </>
  );
};

export default LookupSearch;